import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Leaves } from 'shared/lib/types';

import { DiscountListItem } from 'entities/discount';

type ObjectLeaves = Leaves<DiscountListItem>;

export type TableColumns = Extract<
  ObjectLeaves,
  | 'name'
  | 'startDiscountFormula'
  | 'consumptionDiscountFormula'
  | 'parkingDiscountFormula'
  | 'reserveDiscountFormula'
>;

export type TableColumnsState = Record<TableColumns, boolean>;

const initialState: TableColumnsState = {
  name: true,
  consumptionDiscountFormula: true,
  parkingDiscountFormula: true,
  reserveDiscountFormula: true,
  startDiscountFormula: true,
};

const slice = createSlice({
  name: 'discountsTable',
  initialState,
  reducers: {
    setVisibleColumns: (state, action: PayloadAction<TableColumnsState>) => {
      return action.payload;
    },
  },
});

export const { setVisibleColumns } = slice.actions;
export default slice.reducer;
